import { SubscriptionFeature } from '@kanbu/schema/enums';

import { useCurrentOrganization } from './useCurrentOrganization';
import { useUser } from './useUser';

export function useSubscriptionFeatures() {
  const { hasFeature } = useUser();
  const { organization } = useCurrentOrganization();

  const canUseKbAutoUpdates = hasFeature(SubscriptionFeature.KbAutoUpdates);

  const upgradePath = organization
    ? {
        to: '/organizations/$organizationId/plan-management' as const,
        params: { organizationId: organization.id },
      }
    : undefined;

  return {
    hasFeature,
    canUseKbAutoUpdates,
    isKbAutoUpdatesLocked: !canUseKbAutoUpdates,
    upgradePath,
  };
}
